import React from "react";
import {FormattedMessage} from 'react-intl';
import __i18n from "../intl/__i18n";

export const enum SelectionMode {
    DEFAULT     = 'default',
    MULTIPLE    = 'multiple',
    TAGS        = 'tags'
}


export const enum Platform {
  "NONE"      = "none",
  "WEB"       = "web",
  "ANDROID"   = "android",
  "ANDROID_TV"= "android_tv",
  "WEB_TV"    = "web_tv",
  "IOS"       = "i_os",
}


export const PlatformOptions = [{
  value : Platform.WEB,
  label : __i18n("app.web"),
},{
  value : Platform.NONE,
  label : __i18n("app.other"),
}, {
  value : Platform.ANDROID,
    label : __i18n("app.android"),
}, {
  value : Platform.ANDROID_TV,
    label : __i18n("app.android_tv"),
}, {
value : Platform.WEB_TV,
  label : __i18n("app.web_tv"),
}, {
value : Platform.IOS,
  label : __i18n("app.ios")
}];

export interface LabeledValue {
    key: string;
    label: string;
}



export const enum Interval {
  Second = 'second',
  Minute = 'minute',
  Hour = 'hour',
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Quarter = 'quarter',
  Year = 'year',
}

export const IntervalOptions = [{
  value: Interval.Second,
  label: <FormattedMessage id="app.second" defaultMessage={`Second`}/>,
}, {
  value: Interval.Minute,
  label: <FormattedMessage id="app.minute" defaultMessage={`Minute`}/>,
}, {
  value: Interval.Hour,
  label: <FormattedMessage id="app.hour" defaultMessage={`Hour`}/>,
}, {
  value: Interval.Day,
  label: <FormattedMessage id="app.day" defaultMessage={`Day`}/>,
}, {
  value: Interval.Week,
  label: <FormattedMessage id="app.week" defaultMessage={`Week`}/>,
},{
  value: Interval.Month,
  label: __i18n("Month"),
}, {
  value: Interval.Quarter,
  label: <FormattedMessage id="app.quarter" defaultMessage={`Quarter`}/>
}, {
  value: Interval.Year,
  label: <FormattedMessage id="app.year" defaultMessage={`Year`}/>
}];
